export default "<app-sent-to-britecore-list></app-sent-to-britecore-list>"